/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Ocop_Cta_Link1Inputs */

const vi_sitesettings_ocop_cta_link1 = /** @type {(inputs: Sitesettings_Ocop_Cta_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đích nút mua sản phẩm OCOP`)
};

/**

* @param {Sitesettings_Ocop_Cta_Link1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_ocop_cta_link1 = /** @type {((inputs?: Sitesettings_Ocop_Cta_Link1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Ocop_Cta_Link1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_ocop_cta_link1(inputs)
});
export { sitesettings_ocop_cta_link1 as "siteSettings_ocop_cta_link" }